import { z } from "zod/v4";

export const memberAuditActionSchema = z.enum([
	"role_changed",
	"status_changed",
	"member_type_changed",
	"skill_level_changed",
	"permission_granted",
	"permission_revoked",
	"member_added",
	"member_removed",
	"invite_responded",
]);

export type MemberAuditAction = z.infer<typeof memberAuditActionSchema>;

export const memberAuditEntrySchema = z.object({
	id: z.string().uuid(),
	member_id: z.string().uuid(),
	actor_id: z.string().uuid().nullable().optional(),
	actor_name: z.string().nullable().optional(),
	action: memberAuditActionSchema,
	field: z.string(),
	old_value: z.unknown().optional(),
	new_value: z.unknown().optional(),
	created_at: z.coerce.date(),
});

export type MemberAuditEntry = z.infer<typeof memberAuditEntrySchema>;

export const paginatedMemberAuditSchema = z.object({
	items: z.array(memberAuditEntrySchema),
	total: z.number(),
	limit: z.number(),
	offset: z.number(),
});

export type PaginatedMemberAudit = z.infer<typeof paginatedMemberAuditSchema>;
